import { render } from "./ModulesList.vue?vue&type=template&id=b10ad08c"
import script from "./ModulesList.vue?vue&type=script&lang=js"
export * from "./ModulesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__